import c from 'classnames';
import styles from './MicrobesBg.module.css';
import TopLeftMicrobe from '../../assets/images/topLeft_microbe.svg';
import LeftCenterMicrobe from '../../assets/images/leftCenter_microbe.svg';
import BottomLeftMicrobe from '../../assets/images/bottomLeft_microbe.svg';
import TopRightMicrobe from '../../assets/images/topRight_microbe.svg';
import RightCenterMicrobe from '../../assets/images/rightCenter_microbe.svg';
import BottomRightMicrobe from '../../assets/images/bottomRight_microbe.svg';

export const MicrobesBg = ({ whiteBackground = false }) => {
  return (
    <div
      className={c(styles.container, whiteBackground && styles.bgTransparent)}
    >
      <img src={TopLeftMicrobe} className={c(styles.microbe, styles.topLeft)} />
      <img
        src={LeftCenterMicrobe}
        className={c(styles.microbe, styles.leftCenter)}
      />
      <img
        src={BottomLeftMicrobe}
        className={c(styles.microbe, styles.bottomLeft)}
      />
      <img
        src={TopRightMicrobe}
        className={c(styles.microbe, styles.topRight)}
      />
      <img
        src={RightCenterMicrobe}
        className={c(styles.microbe, styles.rightCenter)}
      />
      <img
        src={BottomRightMicrobe}
        className={c(styles.microbe, styles.bottomRight)}
      />
    </div>
  );
};
